import React, { useEffect, useMemo, useState } from 'react';
import MemberView from './telegram/MemberView';
import AdminView from './telegram/AdminView';

const ROLE_STORAGE_KEY = 'yfight_selected_role_mode';

function TelegramView({
    user,
    isAdmin,
    events,
    selectedEvent,
    selectedEventId,
    setSelectedEventId,
    selectedRegistration,
    onRegistrationSuccess,
    error
}) {
    const roles = Array.isArray(user?.roles) ? user.roles : [];
    const hasMemberRole = roles.includes('member');
    const hasAdminRole = roles.includes('admin');
    const hasMultipleModes = hasMemberRole && hasAdminRole;

    const defaultRole = useMemo(() => {
        if (hasMultipleModes) return null;
        if (hasAdminRole) return 'admin';
        return 'member';
    }, [hasMultipleModes, hasAdminRole]);

    const [activeRoleMode, setActiveRoleMode] = useState(defaultRole);

    useEffect(() => {
        if (!hasMultipleModes) {
            setActiveRoleMode(defaultRole);
            return;
        }

        const saved = window.localStorage.getItem(ROLE_STORAGE_KEY);
        if (saved === 'admin' || saved === 'member') {
            setActiveRoleMode(saved);
        } else {
            setActiveRoleMode(null);
        }
    }, [hasMultipleModes, defaultRole]);

    function chooseRoleMode(mode) {
        setActiveRoleMode(mode);
        try {
            window.localStorage.setItem(ROLE_STORAGE_KEY, mode);
        } catch (_) {}
    }

    const showRoleChooser = hasMultipleModes && !activeRoleMode;

    return (
        <div className="container">
            <div className="welcome-box">
                WELCOME, {user?.profile?.displayName || user?.telegram?.firstName || 'FIGHTER'}
            </div>

            {error && (
                <div style={{ color: '#ff6b6b', marginTop: '1rem' }}>
                    {error}
                </div>
            )}

            {showRoleChooser && (
                <div className="action-row" style={{ marginTop: '1.2rem' }}>
                    <div className="cta-text" style={{ width: '100%' }}>
                        <p>Choose Mode</p>

                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                gap: '0.8rem',
                                marginTop: '0.9rem'
                            }}
                        >
                            <button
                                type="button"
                                onClick={() => chooseRoleMode('member')}
                                style={{
                                    background: 'var(--primary)',
                                    color: '#000',
                                    border: 'none',
                                    padding: '1rem',
                                    borderRadius: '12px',
                                    fontWeight: 900,
                                    cursor: 'pointer'
                                }}
                            >
                                Continue as User
                            </button>

                            <button
                                type="button"
                                onClick={() => chooseRoleMode('admin')}
                                className="refresh-btn"
                                style={{
                                    padding: '1rem',
                                    borderRadius: '12px',
                                    fontWeight: 900
                                }}
                            >
                                Continue as Admin
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {!showRoleChooser && activeRoleMode === 'admin' && (
                <>
                    {hasMultipleModes && (
                        <div style={{ marginTop: '1rem', marginBottom: '0.6rem', textAlign: 'center' }}>
                            <button
                                type="button"
                                className="refresh-btn"
                                onClick={() => chooseRoleMode('member')}
                            >
                                Switch to User Mode
                            </button>
                        </div>
                    )}
                    <AdminView />
                </>
            )}

            {!showRoleChooser && activeRoleMode !== 'admin' && (
                <>
                    {hasMultipleModes && (
                        <div style={{ marginTop: '1rem', marginBottom: '0.6rem', textAlign: 'center' }}>
                            <button
                                type="button"
                                className="refresh-btn"
                                onClick={() => chooseRoleMode('admin')}
                            >
                                Switch to Admin Mode
                            </button>
                        </div>
                    )}

                    <MemberView
                        events={events}
                        selectedEvent={selectedEvent}
                        selectedEventId={selectedEventId}
                        setSelectedEventId={setSelectedEventId}
                        selectedRegistration={selectedRegistration}
                        onRegistrationSuccess={onRegistrationSuccess}
                    />
                </>
            )}
        </div>
    );
}

export default TelegramView;